import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axiosInstance from "../Utils/axiosInstance";
import { handleApiError } from "./apiError.helper";

type ApiRequestOptions = {

  handleError?: (err: unknown) => Error;
  retries?: number;
  retryDelayMs?: number;
};

export async function apiRequest<T = any>(

  config: AxiosRequestConfig,
  options: ApiRequestOptions = {}

): Promise<T | Error> {

  const { handleError = handleApiError, retries = 0, retryDelayMs = 300 } = options;

  let attempt: number = 0;
  while (attempt <= retries) {

    try {

      const resp: AxiosResponse<T> = await axiosInstance.request<T>(config);
      return resp.data;

    } catch (error: unknown) {

      console.log('error from api request helper: ', error);

      // if (error?.name === "AbortError") {
      //   return null;
      // }

      attempt += 1;
      if (attempt > retries) {
        return handleError(error);
      }

      // simple backoff
      await new Promise((r) => setTimeout(r, retryDelayMs));
    }
  }
  return Error("Dummy error: should not reach here");
}

// Convenience wrappers
export const apiGet = <T = any>(url: string, config?: AxiosRequestConfig, options?: ApiRequestOptions) =>
  apiRequest<T>({ method: 'get', url, ...(config || {}) }, options);

export const apiPost = <T = any>(url: string, data?: any, config?: AxiosRequestConfig, options?: ApiRequestOptions) =>
  apiRequest<T>({ method: 'post', url, data, ...(config || {}) }, options);

export const apiPut = <T = any>(url: string, data?: any, config?: AxiosRequestConfig, options?: ApiRequestOptions) =>
  apiRequest<T>({ method: 'put', url, data, ...(config || {}) }, options);

export const apiPatch = <T = any>(url: string, data?: any, config?: AxiosRequestConfig, options?: ApiRequestOptions) =>
  apiRequest<T>({ method: 'patch', url, data, ...(config || {}) }, options);

export const apiDelete = <T = any>(url: string, config?: AxiosRequestConfig, options?: ApiRequestOptions) =>
  apiRequest<T>({ method: 'delete', url, ...(config || {}) }, options);
